import _ from "lodash";

import { AnalyzeSitewideRequestBodyType } from "@intelligems/ig-types";

import {
  IExperienceDashboardFilters,
  initialDashboardFiltersState,
} from "../../../store/types/dashboardFilters";
import {
  initialSitewideDashboardFiltersState,
  ISitewideDashboardFilters,
} from "../../../store/types/sitewideDashboardFilters";

export const hasFiltersBeenModified = (
  dashboardFilters: IExperienceDashboardFilters
) => {
  const reducedDashFilters: Partial<IExperienceDashboardFilters> = {
    channels: dashboardFilters.channels,
    deviceType: dashboardFilters.deviceType,
    visitorType: dashboardFilters.visitorType,
    discountIncludeType: dashboardFilters.discountIncludeType,
    startTime: dashboardFilters.startTime,
    endTime: dashboardFilters.endTime,
    isZScoreEnabled: dashboardFilters.isZScoreEnabled,
    statSigView: dashboardFilters.statSigView,
  };

  const reducedDashInitials: Partial<IExperienceDashboardFilters> = {
    channels: initialDashboardFiltersState.channels,
    deviceType: initialDashboardFiltersState.deviceType,
    visitorType: initialDashboardFiltersState.visitorType,
    discountIncludeType: initialDashboardFiltersState.discountIncludeType,
    startTime: initialDashboardFiltersState.startTime,
    endTime: initialDashboardFiltersState.endTime,
    isZScoreEnabled: initialDashboardFiltersState.isZScoreEnabled,
    statSigView: initialDashboardFiltersState.statSigView,
  };
  return !_.isEqual(reducedDashFilters, reducedDashInitials);
};

export const haveSitewideFiltersBeenModified = (
  dashboardFilters: ISitewideDashboardFilters
) => {
  const reducedDashFilters: Partial<AnalyzeSitewideRequestBodyType> = {
    deviceType: dashboardFilters.deviceType,
    visitorType: dashboardFilters.visitorType,
  };
  const reducedDashInitials: Partial<AnalyzeSitewideRequestBodyType> = {
    deviceType: initialSitewideDashboardFiltersState.deviceType,
    visitorType: initialSitewideDashboardFiltersState.visitorType,
  };
  return !_.isEqual(reducedDashFilters, reducedDashInitials);
};

export const sortExclusionReasons = (array) => {
  return array.sort((a, b) => {
    // First, compare by EXCLUSION_REASON_GROUP
    if (a.EXCLUSION_REASON_GROUP < b.EXCLUSION_REASON_GROUP) return -1;
    if (a.EXCLUSION_REASON_GROUP > b.EXCLUSION_REASON_GROUP) return 1;

    // If EXCLUSION_REASON_GROUP is the same, compare by EXCLUSION_REASON_N
    if (a.EXCLUSION_REASON_N < b.EXCLUSION_REASON_N) return -1;
    if (a.EXCLUSION_REASON_N > b.EXCLUSION_REASON_N) return 1;

    return 0; // Objects are considered equal
  });
};

export function removeNumberAndHyphen(str) {
  // Use regular expression to match the number and hyphen at the beginning of the string
  // and replace it with an empty string
  return str.replace(/^\d+\s*-\s*/, "");
}

export const getIdOfLargestMetric = (
  key: string,
  filterKey: string,
  filterValue: string,
  dataArr: any[]
): null | string => {
  if (dataArr.length === 0) {
    return null;
  }
  const filteredData = dataArr.filter(
    (data) => data[filterKey] === filterValue
  );

  return filteredData.reduce((max, obj) => (obj[key] > max[key] ? obj : max), {
    VISITORS: 0,
    ORDERS: 0,
    CVR: 0,
    TOTAL_REVENUE: 0,
    TOTAL_PRODUCT_COGS: 0,
    TOTAL_SHIPPING_COST: 0,
    TRANSACTION_FEE: 0,
    TOTAL_COST: 0,
    TOTAL_PROFIT: 0,
    REV_PER_VISITOR: 0,
    PROFIT_PER_VISITOR: 0,
    id: 0,
  }).id;
};
